import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgStyle, NgIf } from '@angular/common';

@Component({
    selector: 'app-botao-primario',
    templateUrl: './botao-primario.component.html',
    styleUrls: ['./botao-primario.component.css'],
    standalone: true,
    imports: [NgClass, NgStyle, NgIf]
})
export class BotaoPrimarioComponent {

  @Input() titulo = '';
  @Input() modoDark = false;
  @Input() disabled = false;
  @Input() imagemBtn = null
  @Output() onPress = new EventEmitter(); 
  
  emitirEvento(){
    this.onPress.emit();
  }

}
